import styled, { css } from 'styled-components';
import { layout } from '../../../package.json';

export const NavMobile = styled.ul`
  display: block;
  list-style-type: disc;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  text-align: left;

  font-size: 16px;
  li {
    padding: 10px 10px;
    ul {
      list-style-type: disc;
      padding-left: 20px;
    }
  }
`

interface LiNavMobileProps {
  bLink?: boolean;
}

export const LiNav = styled.li<LiNavMobileProps>`
  ${
      props => props.bLink ? css`
        cursor: pointer;
      ` :
      css`
        list-style-type: none;
      `
    }
`
export const ContainerMobile = styled.div`
  width:100%;
  img {
    margin-top: 15px;
    max-width: 240px;
    max-height:150px;
  }
`

export const ContainerBtns = styled.div`
  height: 75px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #363636;
    font-size: 36px;
  }

  @media (max-width: ${layout.desktop}) {
    display: none;
  }

  @media (max-width: ${layout.desktop_wide}) {
    svg {
      color: #363636;
      /* font-size: 28px;
      margin-right: 21px; */
      :hover {
        color: var(--primary);
        cursor: pointer;
      }
    }
  }
`;

interface ButtonProps {
  bHidden?: boolean;
}

export const Button = styled.div<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 120px;
  height: 75px;
  cursor: pointer;

  span {
    color: #999;
  }

  a {
    text-decoration: none;
    font-size: 13px;
  }

  &:hover {
    > span{
      color: var(--primary);
    }
    svg {
      color: var(--primary);
    }
  }

  ${props => props.bHidden && css`
    @media (max-width: ${layout.desktop}) {
      display: none;
    }
  `}
`;

interface BadgeNumberProps {
  isLoading: boolean;
  number?: number;
}

export const BadgeNumber = styled.div<BadgeNumberProps>`
  width: 25px;
  height: 25px;
  border-radius: 25px;

  ${props => props.isLoading === false && `
    border: 1px solid var(--primary);
    background-color: var(--primary);
  `}

  span {
    color: #FFF;
    font-size: 12px;
    font-weight: 800;
  }

  position: absolute;
  margin-left: 40px;
  margin-top: -35px;

  display: flex;
  align-items: center;
  justify-content: center;

  ${props =>
    props.number === undefined &&
    css`
      display: none;
    `}
`;

export const CartTotal = styled.div`
  margin-top: 8px;

  span {
    font-size: 16px;
    font-weight: 800;
    color: green;
    text-decoration: unset;
  }
`;

